<template>
    <div id="container-pie">
        <v-chart :options="option" :initOptions="initOptions" autoresize ref='my'/>
    </div>
</template>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/polar';
import 'echarts/lib/component/markPoint';
import 'echarts/lib/component/dataZoom';
import 'echarts/lib/component/title';
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'zrender/lib/svg/svg'

export default {
  name: 'pieChart',
  props: {
       data:Object
  },
  data () {
    return {
       
        option:{}
    }
  },
  watch: {

  },
  methods: {
    fontSize(res){
         let clientWidth = window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;
        if (!clientWidth) return;
        let fontSize = (clientWidth / 1920);
        return res*fontSize;
    }
  },
  mounted () {

    // var maxValue = this.yData.reduce((num1, num2) => {return num1 > num2 ? num1 : num2});
    // var mxData = this.xData

    this.option = {
        title:{
            text:this.data.text,
            textAlign:'center',
            textVerticalAlign:'middle',
            bottom: this.fontSize(20),
            left :'50%',
            textStyle:{
                color:'#FFFFFF',
                fontSize: this.fontSize(12)
            }
        },
        legend: {
            orient: 'horizontal',
            bottom: 0,
            itemWidth: this.fontSize(6),
            itemHeight: this.fontSize(6),
            textStyle:{
                color:'#FFFFFF',
                fontSize: this.fontSize(14)
            },
            data: this.data.legendData
        },
        calculable: true,
        series: [
             {
            name: '总计',
            type: 'pie',
            radius: ['50%', '70%'],
            hoverOffset: this.fontSize(10),
            height:'80%',
            clockwise: false,
            left: this.fontSize(100),
            right: this.fontSize(100),
            label:{
                color:'#FFFFFF',
                fontSize: this.fontSize(14),
                lineHeight: this.fontSize(18),
                formatter: '{c} \n {d}%'
            },
            datasetIndex:1,
            data: this.data.data
            }
        ]
        }

         var len=this.data.data.length;
      var currentindex=0;
          this.timer=setInterval(()=>{   
                this.$nextTick(()=>{
                  
                    this.$refs.my.dispatchAction({
                        type: 'highlight',         
                        seriesIndex: 0,
                        dataIndex: currentindex                  
                    })
                  
                      this.$refs.my.dispatchAction({
                          type: 'downplay',
                          seriesIndex: 0,
                          dataIndex:currentindex==0? len-1:currentindex-1
                      });
                })
              currentindex==len-1? currentindex=0:currentindex++;
            },3000)

  },
  beforeDestroy: function() {
            if (this.timer) {
                clearInterval(this.timer);
            }
        },
  components: {
      'v-chart': ECharts
  }
}
</script>
<style lang="scss" type="text/scss">

    #container-pie{
        .echarts{
            width: 100%;
            height: 100%;
        }
    }

</style>